import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { combineLatest, distinctUntilChanged, filter, interval, Subject, takeUntil } from 'rxjs';
import { PanelData } from '../custom-dashboard/custom-dashboard.component';
import { DOCUMENT } from '@angular/common';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { main } from '@popperjs/core';
import { DataPoint } from '@services/datapoints-data.service';
import { Annotations, LinearGaugeComponent } from '@syncfusion/ej2-angular-lineargauge';
import { Annotation } from '@syncfusion/ej2-angular-circulargauge';

@Component({
	selector: 'app-dashboard-linear-gauge',
	templateUrl: './dashboard-linear-gauge.component.html',
	styleUrls: ['./dashboard-linear-gauge.component.scss']
})
export class DashboardLinearGaugeComponent implements OnInit, AfterViewInit, OnChanges {

	/** Math */
	public Math = Math;

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** panelData */
	@Input() panelData: any;

	/** publicPanelData */
	@Input() publicPanelData: PanelData[];

	/** creating */
	@Input() creating: boolean;

	/** titleMenu */
	@Input() titleMenu: MatMenu;

	/** intervalFinish */
	@Output() intervalFinish = new EventEmitter<any>();

	/** Page Refresh Interval object */
	private refreshInterval: any;

	/** refreshTime */
	private refreshTime: number = 0.5;

	/** axes */
	public axes: any[] = [];

	/** axesMultiple */
	public axesMultiple: Object = [{
		line: {
			width: 1
		},
		ranges: [
			{
				start: 0,
				end: 30,
				color: '#FB7D55',
				startWidth: 50,
				endWidth: 50,
				offset: 5
			},
			{
				start: 30,
				end: 65,
				color: '#ECC85B',
				startWidth: 50,
				endWidth: 50,
				offset: 5
			},
			{
				start: 65,
				end: 100,
				color: '#6FC78A',
				startWidth: 50,
				endWidth: 50,
				offset: 5
			}
		],
		majorTicks: {
			interval: 20,
			height: 7,
			width: 1,
			position: 'Outside'
		},
		minorTicks: {
			interval: 10,
			height: 3,
			position: 'Outside'
		},
		labelStyle: {
			position: 'Outside',
			font: { fontFamily: 'inherit' }
		},
		pointers: [
			{
				width: 0
			}
		],
		minimum: 0,
		maximum: 100,
		opposedPosition: true
	}];

	/** titleStyle */
	public titleStyle: Object = {
		fontFamily: 'inherit', fontWeight: 'normal'
	};

	/** mainDiv */
	@ViewChildren('mainlinear') mainDivs: QueryList<ElementRef>;

	/** gaugeWidth */
	public gaugeWidth: string = "200px";

	/** gaugeHeight */
	public gaugeHeight: string = "100px";

	/** isHierarchyNode */
	public isHierarchyNode: boolean = false;

	/** resizeObserver */
	private resizeObserver!: ResizeObserver;

	/** linearGauges */
	@ViewChildren('linearGauge') linearGauges: QueryList<LinearGaugeComponent>;

	/** annotation */
	public annotation: Object = [{
		content: '<div style="font-size: large;">65</div>',
		axisIndex: 0,
		axisValue: 10,
		x: 0,
		y: 35,
		zIndex: '1',
	}];

	/** testingValue */
	@Input() public testingValue: number = 10;

	/** defaultRangeColours */
	public defaultRangeColours: string[] = ["green", "orange", "red"];

	/** currentBorderColour */
	public currentBorderColour: string = "";

	/** indexColours */
	public indexColours: { colour: string, score: number, border: boolean }[] = [];

	/** borderChange */
	@Output() borderChange = new EventEmitter<string>();

	/** rangeWidth */
	public rangeWidth: number = 25;

	/**
	 * Default Constructor
	 * @param globalFunctions globalFunctions  
	 * @param siteSubscriptions siteSubscriptions 
	 * @param document document 
	 * @param vcr vcr 
	 */
	constructor(
		public globalFunctions: GlobalFunctions,
		private siteSubscriptions: siteSubscriptions,
		@Inject(DOCUMENT) public document: Document,
		private vcr: ViewContainerRef
	) {
		/** Get required subscriptions */
		combineLatest([
			this.siteSubscriptions.selectedOrganisation$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
		]).pipe(
			// Ensure that subscriptions are not null or undefined
			filter(([selectedAccount]) => !!selectedAccount)
		).subscribe({
			next: ([selectedAccount]) => {
			},
			error: (error) => {
				this.globalFunctions.HandleError(error, "Error: Error in one of the combined subscriptions", false);
			}
		});
	}

	/**
	 * ngOnChanges
	 * @param changes changes 
	 */
	ngOnChanges(changes: SimpleChanges): void {
		if (changes["publicPanelData"] && !changes["publicPanelData"].firstChange) {
			console.log("");
		}
	}

	/**
	 * ngAfterViewInit
	 */
	ngAfterViewInit(): void {
		if (this.panelData && false) {
			setTimeout(() => {
				const mainDiv = this.mainDivs.find((x) => x.nativeElement.id == `linear_${this.panelData.id}`);
				this.resizeObserver = new ResizeObserver((entries) => {
					for (let entry of entries) {
						if (mainDiv) {
							const dpname = mainDiv.nativeElement.getElementsByClassName('_dp-name')[0];
							const height = mainDiv.nativeElement.offsetHeight;
							const width = mainDiv.nativeElement.offsetWidth;
							this.gaugeHeight = `${height / (this.panelData.datapoints?.length ?? 1)}px`;
							this.gaugeWidth = `${width - dpname?.offsetWidth}px`;

							// const gauges = mainDiv.nativeElement.getElementsByClassName("_linear-gauge");
							// if (gauges.length > 0) {
							// 	for (let i: number = 0; i < gauges.length; i++) {
							// 		gauges[i]
							// 	}
							// }
						}
					}
				});

				if (mainDiv) {
					this.resizeObserver.observe(mainDiv.nativeElement);
				}
			}, 0);
		}
	}

	/**
	 * ngOnInit
	 */
	ngOnInit(): void {
		if (this.panelData) {
			this.refreshInterval = interval((this.refreshTime * 60000)).pipe(takeUntil(this.finalise)).subscribe(() => {
				this.intervalFinish.emit(this.panelData);
			});
			this.isHierarchyNode = this.panelData.isHierarchy ?? false;
			for (let i: number = 0; i < this.panelData.datapoints.length; i++) {
				const min: number = Math.min(...this.panelData.ranges.map((r: any) => r.min[i]).filter((x: any) => x != undefined));
				const max: number = Math.max(...this.panelData.ranges.map((r: any) => r.max[i]).filter((x: any) => x != undefined));
				let newAxis: any = [{
					line: {
						width: 1
					},
					majorTicks: {
						interval: (max - min) / 5,
						height: 7,
						width: 1,
						position: 'Outside'
					},
					minorTicks: {
						interval: (max - min) / 10,
						height: 3,
						position: 'Outside'
					},
					labelStyle: {
						position: 'Outside',
						font: { fontFamily: 'inherit' }
					},
					minimum: min,
					maximum: max,
					opposedPosition: true,
					ranges: [],
					pointers: [{
						width: 10,
						value: min + ((max - min) / 2),
						height: 10,
						enableDrag: true,
						placement: 'Near',
						// type: 'Bar',
						markerType: "Triangle",
						offset: 10,
						color: '#0074E3',
						animationDuration: 1500
					}],
				}];
				// x.color[i] ?? ['green', 'orange', 'red'][["Low", "Normal", "High"].indexOf(x.name[i])]
				this.panelData.ranges.forEach((x: any, index: number) => {
					if (x.min.length > 0 && x.max.length > 0) {
						newAxis[0].ranges.push({
							start: x.min[i],
							end: x.max[i],
							color: x.color[i] ?? ['green', 'orange', 'red'][["Low", "Normal", "High"].indexOf(x.name[i])],
							startWidth: 25,
							endWidth: 25,
							// offset: 5
						});
					}
				});
				this.axes.push(newAxis);
			}
		}
	}

	/**
	 * resolveRangeColour
	 * @param value value 
	 * @param index index 
	 * @returns 
	 */
	resolveRangeColour(value: number, index: number): string {	
		let result: string = "";
		let newBorderColour: string = "";
		let score: number = 0;
		let border: boolean = false;
		const rangeValues = this.panelData.ranges.map((x: any) => [x.min[index], x.max[index]]);
		if (value <= rangeValues[0][1]) {
			const range = this.panelData.ranges[0];
			result = range.color[index] || this.getDefaultRangeColour(range, index, 0);
			score = 1;
			border = range.createsBorder[index];
		} else if (value >= rangeValues[1][0] && value <= rangeValues[1][1]) {
			const range = this.panelData.ranges[1];
			result = range.color[index] || this.getDefaultRangeColour(range, index, 1);
			score = 2;
			border = range.createsBorder[index];
		} else if (value >= rangeValues[2][0]) {
			const range = this.panelData.ranges[2];
			result = range.color[index] || this.getDefaultRangeColour(range, index, 2);
			score = 3;
			border = range.createsBorder[index];
		}
		this.indexColours[index] = { colour: result, score: score, border: border };
		let currentHighest: number = 0;
		let currentHighestColour: string = "";
		let shouldCreateBorder: boolean = false;
		this.indexColours.forEach((colour: any) => {
			if (colour.score > currentHighest) {
				currentHighest = colour.score;
				currentHighestColour = colour.colour;
				shouldCreateBorder = colour.border;
			}
		});
		if (shouldCreateBorder) {
			this.currentBorderColour = currentHighestColour;
			this.borderChange.emit(this.currentBorderColour);
		}
		return result;
	}

	/**
	 * getDefaultRangeColour
	 * @param range range 
	 */
	getDefaultRangeColour(range: any, index: number, rangeIdx: number): string {
		let result: string = "";
		if (!range.name[index]) {
			result = this.defaultRangeColours[rangeIdx];
		} else if (["Low", "Normal", "High"].includes(range.name[index])) {
			switch (range.name[index]) {
				case "Low":
					result = this.defaultRangeColours[0];
					break;
				case "Normal":
					result = this.defaultRangeColours[1];
					break;
				case "High":
					result = this.defaultRangeColours[2];
					break;
			}
		}
		return result;
	}
}

LinearGaugeComponent.Inject(Annotations);
